import { T } from "@repo/transifex";
import type { FreedompayConnectionStatus } from "~/providers/app/types";

const BADGE_CLASSNAME =
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-sm font-medium";

const VARIANT: Record<FreedompayConnectionStatus, string> = {
  unknown: "bg-interface-neutral-2 text-interface-neutral-6",
  connected: "bg-interface-positive-1 text-interface-positive-3",
  reconnecting: "bg-interface-warning-1 text-interface-warning-4",
  disconnected: "bg-interface-negative-1 text-interface-negative-2"
};

const LABEL: Record<FreedompayConnectionStatus, React.ReactNode> = {
  unknown: <T _str="Checking..." />,
  connected: <T _str="Connected" />,
  reconnecting: <T _str="Reconnecting..." />,
  disconnected: <T _str="Not connected" />
};

export const FreedomPayStatusBadge = ({
  status
}: {
  status: FreedompayConnectionStatus;
}) => (
  <span className={`${BADGE_CLASSNAME} ${VARIANT[status]}`}>
    {LABEL[status]}
  </span>
);
